"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetActInfo = exports.GetFlashInfo = exports.FixProductModuleFetch = exports.GetModules = exports.GetPageSaveLog = exports.SetVersion = exports.CopyPlayground = exports.GetPlaygroundListByGroup = exports.GetPlaygroundList = exports.DeletePlayground = exports.GetPlayground = exports.CreatePlayground = exports.PublishPlayground = exports.UpdatePlayground = exports.SavePlayground = exports.ListGroup = exports.CreateGroup = exports.TActState = exports.ActType = exports.AreaColor = exports.Shape = exports.TPlatform = exports.TPlaygroundType = exports.TModuleType = void 0;
var webapi_1 = require("../webapi");
var TModuleType;
(function (TModuleType) {
    TModuleType["TCollections"] = "TCollections";
    TModuleType["TMostPopular"] = "TMostPopular";
    TModuleType["THotCategories"] = "THotCategories";
    TModuleType["TBanner"] = "TBanner";
    TModuleType["TFlash"] = "TFlash";
    TModuleType["TCategory"] = "TCategory";
    TModuleType["TSwiper"] = "TSwiper";
    TModuleType["TQuickNav"] = "TQuickNav";
    TModuleType["THotKeywords"] = "THotKeywords";
    TModuleType["THotList"] = "THotList";
    TModuleType["TProductRecommend"] = "TProductRecommend";
    TModuleType["TCategoryExtension"] = "TCategoryExtension";
    TModuleType["TTopBanner"] = "TTopBanner";
    TModuleType["TMagicBannerType"] = "TMagicBannerType";
    TModuleType["TMultiProductModuleType"] = "TMultiProductModuleType";
    TModuleType["TPageTitleLineType"] = "TPageTitleLineType";
    TModuleType["TNavIcons"] = "TNavIcons";
    TModuleType["TRichText"] = "TRichText";
    TModuleType["TCountdownBanner"] = "TCountdownBanner";
    TModuleType["TMagicVoucher"] = "TMagicVoucher";
    TModuleType["TDiscount"] = "TDiscount";
    TModuleType["TMultiFlash"] = "TMultiFlash";
    TModuleType["TSideBanner"] = "TSideBanner";
    TModuleType["TMultiHeroDeal"] = "TMultiHeroDeal";
    TModuleType["TStickBotomTab"] = "TStickBotomTab";
    TModuleType["TLogo"] = "TLogo";
    TModuleType["THomeBanner"] = "THomeBanner";
    TModuleType["TNavIconGroups"] = "TNavIconGroups";
    TModuleType["TMultiCollection"] = "TMultiCollection";
    TModuleType["TMultiRecPurTab"] = "TMultiRecPurTab";
    TModuleType["TBottomIcons"] = "TBottomIcons";
    TModuleType["TShakeIcon"] = "TShakeIcon";
    TModuleType["TTimelineBanner"] = "TTimelineBanner";
    TModuleType["TMultiCollectionTwo"] = "TMultiCollectionTwo";
    TModuleType["TNoLoginBanner"] = "TNoLoginBanner";
    TModuleType["TFlashArea"] = "TFlashArea";
    TModuleType["TMillion"] = "TMillion";
    TModuleType["TEvent"] = "TEvent";
    TModuleType["TMagicBannerTwo"] = "TMagicBannerTwo";
    TModuleType["TCoupon"] = "TCoupon";
    TModuleType["TAll"] = "TAll";
})(TModuleType = exports.TModuleType || (exports.TModuleType = {}));
var TPlaygroundType;
(function (TPlaygroundType) {
    TPlaygroundType["TPlaygroundAll"] = "TPlaygroundAll";
    TPlaygroundType["TPlaygroundPCHome"] = "TPlaygroundPCHome";
    TPlaygroundType["TPlaygroundTights"] = "TPlaygroundTights";
    TPlaygroundType["TPlaygroundSeller"] = "TPlaygroundSeller";
    TPlaygroundType["TPlaygroundAppHome"] = "TPlaygroundAppHome";
})(TPlaygroundType = exports.TPlaygroundType || (exports.TPlaygroundType = {}));
var TPlatform;
(function (TPlatform) {
    TPlatform["Pc"] = "Pc";
    TPlatform["Mobile"] = "Mobile";
})(TPlatform = exports.TPlatform || (exports.TPlatform = {}));
var Shape;
(function (Shape) {
    Shape["Square"] = "Square";
    Shape["RectangleA"] = "RectangleA";
    Shape["RectangleB"] = "RectangleB";
})(Shape = exports.Shape || (exports.Shape = {}));
var AreaColor;
(function (AreaColor) {
    AreaColor["TextColor"] = "TextColor";
    AreaColor["TextSelectedColor"] = "TextSelectedColor";
    AreaColor["TagSelectedColor"] = "TagSelectedColor";
})(AreaColor = exports.AreaColor || (exports.AreaColor = {}));
var ActType;
(function (ActType) {
    ActType["NotActType"] = "NotActType";
    ActType["Flash"] = "Flash";
    ActType["Friend"] = "Friend";
    ActType["HuntHoney"] = "HuntHoney";
})(ActType = exports.ActType || (exports.ActType = {}));
var TActState;
(function (TActState) {
    TActState["UnkonwnActState"] = "UnkonwnActState";
    TActState["ComingSoon"] = "ComingSoon";
    TActState["OnGoing"] = "OnGoing";
    TActState["Ended"] = "Ended";
})(TActState = exports.TActState || (exports.TActState = {}));
function CreateGroup(payload) {
    return webapi_1.default("page.Admin/CreateGroup", payload);
}
exports.CreateGroup = CreateGroup;
function ListGroup(payload) {
    return webapi_1.default("page.Admin/ListGroup", payload);
}
exports.ListGroup = ListGroup;
function SavePlayground(payload) {
    return webapi_1.default("page.Admin/SavePlayground", payload);
}
exports.SavePlayground = SavePlayground;
function UpdatePlayground(payload) {
    return webapi_1.default("page.Admin/UpdatePlayground", payload);
}
exports.UpdatePlayground = UpdatePlayground;
function PublishPlayground(payload) {
    return webapi_1.default("page.Admin/PublishPlayground", payload);
}
exports.PublishPlayground = PublishPlayground;
function CreatePlayground(payload) {
    return webapi_1.default("page.Admin/CreatePlayground", payload);
}
exports.CreatePlayground = CreatePlayground;
function GetPlayground(payload) {
    return webapi_1.default("page.Admin/GetPlayground", payload);
}
exports.GetPlayground = GetPlayground;
function DeletePlayground(payload) {
    return webapi_1.default("page.Admin/DeletePlayground", payload);
}
exports.DeletePlayground = DeletePlayground;
function GetPlaygroundList(payload) {
    return webapi_1.default("page.Admin/GetPlaygroundList", payload);
}
exports.GetPlaygroundList = GetPlaygroundList;
function GetPlaygroundListByGroup(payload) {
    return webapi_1.default("page.Admin/GetPlaygroundListByGroup", payload);
}
exports.GetPlaygroundListByGroup = GetPlaygroundListByGroup;
function CopyPlayground(payload) {
    return webapi_1.default("page.Admin/CopyPlayground", payload);
}
exports.CopyPlayground = CopyPlayground;
function SetVersion(payload) {
    return webapi_1.default("page.Admin/SetVersion", payload);
}
exports.SetVersion = SetVersion;
function GetPageSaveLog(payload) {
    return webapi_1.default("page.Admin/GetPageSaveLog", payload);
}
exports.GetPageSaveLog = GetPageSaveLog;
function GetModules(payload) {
    return webapi_1.default("page.Admin/GetModules", payload);
}
exports.GetModules = GetModules;
function FixProductModuleFetch(payload) {
    return webapi_1.default("page.Admin/FixProductModuleFetch", payload);
}
exports.FixProductModuleFetch = FixProductModuleFetch;
function GetFlashInfo(payload) {
    return webapi_1.default("page.Admin/GetFlashInfo", payload);
}
exports.GetFlashInfo = GetFlashInfo;
function GetActInfo(payload) {
    return webapi_1.default("page.Admin/GetActInfo", payload);
}
exports.GetActInfo = GetActInfo;
exports.default = {
    CreateGroup: CreateGroup,
    ListGroup: ListGroup,
    SavePlayground: SavePlayground,
    UpdatePlayground: UpdatePlayground,
    PublishPlayground: PublishPlayground,
    CreatePlayground: CreatePlayground,
    GetPlayground: GetPlayground,
    DeletePlayground: DeletePlayground,
    GetPlaygroundList: GetPlaygroundList,
    GetPlaygroundListByGroup: GetPlaygroundListByGroup,
    CopyPlayground: CopyPlayground,
    SetVersion: SetVersion,
    GetPageSaveLog: GetPageSaveLog,
    GetModules: GetModules,
    FixProductModuleFetch: FixProductModuleFetch,
    GetFlashInfo: GetFlashInfo,
    GetActInfo: GetActInfo
};
